// Feature-flagged ad slot. Ships OFF by default and renders nothing unless the
// page has ads_enabled AND consent is accepted. Reserves fixed dimensions to
// protect CLS. Never placed above or inside the calculator.
import { getConsent } from "../lib/analytics";

export const AdSlot = ({ enabled = false, label = "Advertisement", height = 250 }) => {
  if (!enabled) return null;
  if (getConsent() !== "accepted") return null;

  return (
    <div
      className="my-8 flex items-center justify-center rounded-md border border-dashed border-border bg-secondary/40 text-xs uppercase tracking-wider text-muted-foreground"
      style={{ height, minHeight: height }}
      data-testid="ad-slot"
      aria-label={label}
    >
      {label}
    </div>
  );
};
